import * as React from 'react';

import { BaseComponent } from './BaseComponent';

export interface LongButtonProps {
    size?: 'small';
    className?: string;
    active?: boolean;
    icon?: string;
    arrow?: boolean;
    shortBorder?: boolean;
    checked?: boolean;
    toggled?: boolean;
    onClick?: (event?: React.MouseEvent) => void;
    disabled?: boolean;
    link?: string;
    id?: string;
}

export class LongButton extends BaseComponent<LongButtonProps, {}> {

    public render(): JSX.Element {
        if (this.props.link) {
            return (
                <a
                    className={'long-button-background' + (this.props.active ? ' active' : '')}
                    href={this.props.link}
                    target="_blank"
                    id={this.props.id ? this.props.id : ''}
                >
                    <div className={this.cssClass()}>
                        {this.props.children}
                    </div>
                </a>
            );
        }
        return (
            <div className={'long-button-background' + (this.props.active ? ' active' : '')} onClick={this.onClick} id={this.props.id ? this.props.id : ''}>
                <div className={this.cssClass()}>
                    {this.props.children}
                </div>
            </div>
        );
    }

    protected onClick = (event: React.MouseEvent): void => {
        if (this.props.onClick && !this.props.disabled) {
            this.props.onClick(event);
        }
    };

    protected cssClass = (): string => {
        const result: Array<string> = ['long-button'];
        if (this.props.toggled != null || this.props.icon != null) {
            result.push('with-icon');

            if (this.props.icon != null) {
                result.push(this.props.icon);
            }

            if (this.props.toggled != null) {
                result.push('toggle-box');
                if (this.props.toggled === true) {
                    result.push('checked');
                }
            }
        }

        if (this.props.disabled) {
            result.push('not-available');
        }

        if (this.props.arrow) {
            result.push('with-arrow');
        }
        if (this.props.shortBorder) {
            result.push('short-border');
        }
        if (this.props.className) {
            result.push(this.props.className);
        }
        if (this.props.size === 'small') {
            result.push('small-size');
        }
        if (this.props.checked != null) {
            result.push('with-check');
            if (this.props.checked === true) {
                result.push('checked');
            }
        }
        return result.join(' ');
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LongButton.tsx